function loadCircuitImage(circuitId){
    $(this).request('onCircuitSelect', {
        data:{circuitId:circuitId},
        update: { MultipleDestination: '#MultipleDestinationDiv' },
        complete:function() {
          loadCircuitMap();
        }
    });
}
    
function loadCircuitFirstImage(circuitId){
    $(this).request('onCircuitSelect', {
        data:{circuitId:circuitId},
        update: { MultipleDestination: '#MultipleDestinationDiv' },
    });
}
    
var mapLoaded = 0
var coordinates = [];
var map;
function loadCircuitMap(){
    coordinates = [];
    $('.location_name_inner').each(function(){
        console.log($(this).attr('coordinates'));
        coordinates.push( $.parseJSON($(this).attr('coordinates')));
    })

    if(coordinates){
        if(!mapLoaded){
            var s     = document.createElement("script");
            s.type    = "text/javascript";
            s.src     = "//maps.googleapis.com/maps/api/js?key=AIzaSyDmvwhO9L89V8BfwxbmKfYT0PHb34crkJM&callback=markerLabelInit";
            // Use any selector
            $("footer").after(s);
            mapLoaded = 1
        } else {
            map = new google.maps.Map(document.getElementById('circuit_map_div'), {
              zoom: 6,
              center: (coordinates.length > 2 ? coordinates[1] : coordinates[0])
            });
            initMap();
        }
    }
}

function initMap() {
    var icon = new google.maps.MarkerImage(
            assetBaseUrl + 'images/national.png',
            new google.maps.Size(70, 70),
            new google.maps.Point(0, 0),
            new google.maps.Point(34, 72));

    var directionsService = new google.maps.DirectionsService;
    var directionsRenderer = new google.maps.DirectionsRenderer;
    /*var map = new google.maps.Map(document.getElementById('circuit_map_div'), {
      zoom: 6,
      center: (coordinates.length > 2 ? coordinates[1] : coordinates[0])
    });*/
    directionsRenderer.setMap(map);

    var waypts = [];

    if(coordinates.length > 2){
        for (var i = 1; i < (coordinates.length-1); i++) {
            waypts.push({
              location: coordinates[i],
              stopover: true
            });
        }
    }

    directionsService.route({
      origin: coordinates[0],
      destination: coordinates[coordinates.length-1],
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: 'DRIVING'
    }, function(response, status) {
      if (status === 'OK') {

        //directionsRenderer.setDirections(response);
        new google.maps.DirectionsRenderer({
            map: map,
            directions: response,
            suppressMarkers: true
        });

        var leg = response.routes[0].legs[0];
        for (var i = 0; i < coordinates.length; i++) {
            var marker = new MarkerWithLabel({
                position: coordinates[i],
                icon: assetBaseUrl + 'images/map/national.png',
                draggable: false,
                map: map,
                labelContent: $('.resort_name_'+(i+1)).text(),
                labelClass: "map-icon-label dom", // the CSS class for the label
                //labelStyle: {top: "0px", left: "-21px", opacity: 0.75},
                labelVisible: true
           });
        }
      } else {
        console.log('Directions request failed due to ' + status);
      }
    });
}


function markerLabelInit(){
    var x     = document.createElement("script");
    x.type    = "text/javascript";
    x.src     =  assetBaseUrl + 'js/gmaps-markerwithlabel-1.9.1.js';
    // Use any selector
    $("footer").after(x);

    map = new google.maps.Map(document.getElementById('circuit_map_div'), {
      zoom: 6,
      center: (coordinates.length > 2 ? coordinates[1] : coordinates[0])
    });
    window.setTimeout(initMap, 1000);
}

$(document).ready(function () {
    //Load default circuit
    // loadCircuitMap()

    $('.circuit_res_data').click(function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var country_id = $(this).find('strong').attr('circuit_id');
      var resort_id = $(this).find('strong').attr('resort_id');
      $.ajax({
          type: "GET",
          url: assetBaseUrl + "circuit-resort-data",
          data: {country_id:country_id,resort_id:resort_id},
          success: function (data) {
              if (data.status) {
                $('#circuit_res').html(data.html);
                loadCircuitMap();
              }
          }
      });
  });
});
